/**
 * 🔐 Frontend Route Encryption Helper
 * Calls the backend API to get an AES-256 encrypted version of a lead ID
 * safe for use in public-facing URLs.
 *
 * Usage:
 *   const encId = await getEncryptedLeadId(lead._id);
 *   const url = `${window.location.origin}/clinical-intake/${encId}`;
 */

import api from '../services/api';

/**
 * Returns an encrypted version of a lead ID for embedding in public share URLs.
 * Falls back to the plain ID if the API call fails (backward compat / dev mode).
 *
 * @param {string} leadId - Raw MongoDB ObjectId string
 * @returns {Promise<string>} Encrypted ID or plain ID as fallback
 */
export const getEncryptedLeadId = async (leadId) => {
  if (!leadId) return leadId;
  try {
    const res = await api.get(`/leads/encrypt/${leadId}`);
    return res.data?.data?.encryptedId || leadId;
  } catch (err) {
    console.warn('[ROUTE_ENCRYPT] Could not encrypt lead ID, using plain ID as fallback:', err.message);
    return leadId;
  }
};
